<div class="container py-3">
  <form [formGroup]="registrationForm">
    <!-- AMENDMENTS -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="election-title">Amendments in Society Registration</h5>
          </div>
          <div class="card-body">
            <div class="row g-2 align-items-end">
              <div class="col-md-4 mb-2">
                <label class="form-label m-0">Amendment In</label>
                <select
                  class="form-control"
                  #amendmentType
                  (change)="onAmendmentTypeChange($event)"
                >
                  <option value="">Select Amendment</option>
                  <option *ngFor="let item of AmendmentType" [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-4 mb-2">
                <label class="form-label m-0">Resolution No</label>
                <input
                  type="text"
                  class="form-control"
                  #resolutionNo
                  placeholder="Enter Resolution No"
                />
              </div>

              <div class="col-md-4 mb-2">
                <label class="form-label m-0">Resolution Date</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="dd/mm/yyyy"
                  readonly
                  (click)="startPicker.showPicker()"
                  [value]="
                    startPicker.value
                      ? (startPicker.value | date: 'dd/MM/yyyy')
                      : ''
                  "
                />

                <input
                  #startPicker
                  type="date"
                  class="form-control"
                  #resolutionDate
                  style="position: absolute; opacity: 0; pointer-events: none"
                />
              </div>

              <div class="col-md-12 text-end mt-2">
                <!-- <button type="button" class="btn btn-primary" (click)="addAmendment({ 
      amendmentType: amendmentType.value,
      resolutionNo: resolutionNo.value,
      resolutionDate: resolutionDate.value
 })">
                                    Add
                                </button> -->
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="
                    addAmendment(
                      {
                        amendmentType: amendmentType.value,
                        resolutionNo: resolutionNo.value,
                        resolutionDate: resolutionDate.value,
                      },
                      amendmentType,
                      resolutionNo,
                      resolutionDate
                    )
                  "
                >
                  Add
                </button>
              </div>

              <div class="col-lg-12 mt-3">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Amendment In</th>
                        <th>Resolution No</th>
                        <th>Resolution Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of amendmentsList; let i = index">
                        <td>{{ getAmendmentName(item.amendmentType) }}</td>
                        <td>{{ item.resolutionNo }}</td>
                        <td>{{ item.resolutionDate | date: "dd/MM/yyyy" }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            (click)="removeAmendment(i)"
                          >
                            <i class="bi bi-trash3"></i>
                          </button>
                          &nbsp;
                          <button
                            *ngIf="shouldShowAddButton(item.amendmentType)"
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="
                              openSelectedAmendmentModal(item.amendmentType)
                            "
                          >
                            Add
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="BylawsModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <form [formGroup]="nameForm">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="election-title">Change Name of the Society</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div class="modal-body">
              <div class="row g-2">
                <!-- Existing -->
                <div class="col-lg-12">
                  <label class="form-label m-0">Existing Details</label>
                  <textarea
                    class="form-control"
                    formControlName="existingDetails"
                  ></textarea>
                </div>

                <!-- Proposed -->
                <div class="col-lg-12">
                  <label class="form-label m-0">Proposed Change</label>
                  <textarea
                    class="form-control"
                    formControlName="proposedChange"
                  ></textarea>
                </div>

                <!-- Purpose -->
                <div class="col-lg-12">
                  <label class="form-label m-0">
                    Purpose Change <span class="text-danger">*</span>
                  </label>
                  <textarea
                    class="form-control"
                    formControlName="purposesChange"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                class="btn btn-primary"
                (click)="addBylaw(nameForm.getRawValue())"
                data-bs-dismiss="modal"
              >
                Add
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div
      class="modal fade"
      id="AddObjective"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="AddObjectiveLabel"
      aria-hidden="true"
      style="background: rgba(0, 0, 0, 0.8)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <form [formGroup]="objectiveForm">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="AddObjectiveLabel">
                Manage Objectives
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div class="modal-body" style="max-height: 65vh; overflow-y: auto">
              <h6 class="election-title"><b>Existing Objectives</b></h6>

              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th width="20%" class="text-center">S.No.</th>
                    <th>Objective</th>
                    <th width="20%" class="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let obj of objectiveList; let i = index">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>{{ obj.sSocietyObjDes }}</td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        (click)="deleteObj(i, obj)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div *ngIf="objectiveList?.length === 0" class="text-muted mb-3">
                No objectives added yet.
              </div>

              <hr />

              <label class="text-dark">
                Add New Objective <span class="text-danger">*</span>
              </label>
              <textarea
                class="form-control"
                rows="3"
                placeholder="Enter Aims/Objective of Society"
                formControlName="sSocietyObjDes"
                [ngClass]="{
                  'invalid-input':
                    objectiveForm.get('sSocietyObjDes')?.errors && isSubmitObj,
                }"
              ></textarea>

              <div class="col-lg-12 mt-3">
                <label for="proposedChange" class="text-dark">
                  Purpose Change <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="Enter purpose change"
                  formControlName="purposeChange"
                  [ngClass]="{
                    'invalid-input':
                      objectiveForm.get('purposeChange')?.errors && isSubmitObj,
                  }"
                ></textarea>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary"
                (click)="submitObjective()"
              >
                Add Objective
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <form [formGroup]="addressForm">
      <div
        class="modal fade"
        id="AddressModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="election-title">Change Address of the Society</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div class="modal-body" style="max-height: 65vh; overflow-y: auto">
              <div class="row g-3">
                <div class="col-lg-8">
                  <label class="form-label fw-semibold"
                    >Existing Address of the Head Office of Society</label
                  >
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="existingAddress"
                  ></textarea>
                </div>

                <div class="col-lg-4">
                  <label class="form-label fw-semibold"
                    >Head Office District</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [value]="societyDetails.sdistrictname"
                    formControlName="existingDistrict"
                  />
                </div>

                <hr />

                <div class="col-lg-8">
                  <label class="form-label fw-semibold">
                    Proposed Address of the Head Office of Society
                    <span class="text-danger">*</span>
                  </label>
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="proposedAddress"
                    placeholder="Enter Proposed Address of the Head Office of Society"
                  ></textarea>
                  <div
                    *ngIf="
                      addressForm.get('proposedAddress')?.invalid &&
                      addressForm.get('proposedAddress')?.touched
                    "
                    class="text-danger"
                  >
                    Proposed Address is required.
                  </div>
                </div>

                <div class="col-lg-4">
                  <label class="form-label fw-semibold">
                    Head Office District <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    formControlName="proposedDistrict"
                  >
                    <option value="">Select District</option>
                    <option *ngFor="let item of districts" [value]="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      addressForm.get('proposedDistrict')?.invalid &&
                      addressForm.get('proposedDistrict')?.touched
                    "
                    class="text-danger"
                  >
                    Proposed District is required.
                  </div>
                </div>

                <div class="col-lg-12">
                  <label class="form-label fw-semibold">
                    Purpose of Change <span class="text-danger">*</span>
                  </label>
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="purposeChange"
                    placeholder="Enter reason for address change"
                  ></textarea>
                  <div
                    *ngIf="
                      addressForm.get('purposeChange')?.invalid &&
                      addressForm.get('purposeChange')?.touched
                    "
                    class="text-danger"
                  >
                    Purpose of Change is required.
                  </div>
                </div>

                <div class="col-lg-12">
                  <label class="form-label fw-semibold d-block"
                    >NOC (No Objection Certificate)<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <a
                    href="javascript:void(0)"
                    class="text-primary text-decoration-underline mb-2 d-inline-block"
                    (click)="generateNoc()"
                  >
                    <i class="fa fa-file-text me-1"></i> Generate NOC
                  </a>
                  <input
                    type="file"
                    class="form-control"
                    (change)="onBylawFileSelected($event)"
                  />
                  <div
                    *ngIf="
                      addressForm.get('nocFile')?.invalid &&
                      addressForm.get('nocFile')?.touched
                    "
                    class="text-danger mt-1"
                  >
                    NOC file is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button
                class="btn btn-primary"
                [disabled]="addressForm.invalid"
                (click)="submitAddressChange()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="areaForm">
      <div
        class="modal fade"
        id="AreaModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="election-title">Extension of Area of Operation</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div class="modal-body">
              <div class="row g-2">
                <div class="col-lg-12">
                  <label class="form-label m-0">Existing Area</label>
                  <input
                    type="text"
                    class="form-control"
                    [value]="societyDetails.sareaoperationname"
                    formControlName="existingArea"
                  />
                </div>

                <div class="col-lg-12">
                  <label class="form-label m-0">
                    Proposed Area Extension <span class="text-danger">*</span>
                  </label>

                  <select
                    class="form-control"
                    formControlName="proposedAreaExtension"
                  >
                    <option value="">Select Area</option>
                    <option
                      *ngFor="let item of operationofArea2006"
                      [value]="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>

                  <div
                    class="text-danger"
                    *ngIf="
                      areaForm.get('proposedAreaExtension')?.touched &&
                      areaForm.get('proposedAreaExtension')?.invalid
                    "
                  >
                    Please select area
                  </div>
                </div>

                <div class="col-lg-12">
                  <label class="form-label fw-semibold">
                    Purpose of Change <span class="text-danger">*</span>
                  </label>

                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="purposeChange"
                    placeholder="Enter reason for area extension"
                  >
                  </textarea>

                  <div
                    class="text-danger"
                    *ngIf="
                      areaForm.get('purposeChange')?.touched &&
                      areaForm.get('purposeChange')?.invalid
                    "
                  >
                    Purpose is required
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                class="btn btn-primary"
                (click)="addAreaExtension()"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="election-title">Upload Documents</h5>
          </div>
          <div class="card-body">
            <div class="row g-2">
              <div class="col-md-4">
                <div class="d-flex align-items-center gap-2">
                  <label class="form-label m-0">Form IV</label>
                  <a
                    href="javascript:void(0)"
                    class="text-primary fw-semibold text-decoration-none"
                    (click)="generateFormIV()"
                  >
                    <i class="fa fa-file-text me-1"></i> Generate
                  </a>
                </div>

                <input
                  type="file"
                  class="form-control mt-1"
                  (change)="onFileSelected($event, 'formIV')"
                />
                <small
                  *ngIf="this.uploadedFiles['formIV']?.fileName"
                  class="text-success"
                >
                  Selected: {{ this.uploadedFiles["formIV"]?.fileName }}
                </small>
                <div *ngIf="uploadedFiles['formIV']?.content" class="mt-1">
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    (click)="
                      previewFiles(
                        uploadedFiles['formIV'].content,
                        'viewDocumentDetails'
                      )
                    "
                  >
                    View PDF
                  </button>
                </div>
              </div>

              <div class="col-md-4">
                <div class="d-flex align-items-center gap-2">
                  <label class="form-label m-0">Comparative Chart</label>
                  <a
                    href="javascript:void(0)"
                    class="text-primary fw-semibold text-decoration-none"
                    (click)="generateAnnexureForm()"
                  >
                    <i class="fa fa-file-text me-1"></i> Generate
                  </a>
                </div>
                <input
                  type="file"
                  class="form-control"
                  (change)="onFileSelected($event, 'comparativeChart')"
                />
                <small
                  *ngIf="this.uploadedFiles['comparativeChart']?.fileName"
                  class="text-success"
                >
                  Selected:
                  {{ this.uploadedFiles["comparativeChart"]?.fileName }}
                </small>
                <div
                  *ngIf="uploadedFiles['comparativeChart']?.content"
                  class="mt-1"
                >
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    (click)="
                      previewFiles(
                        uploadedFiles['comparativeChart'].content,
                        'viewDocumentDetails'
                      )
                    "
                  >
                    View PDF
                  </button>
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label m-0">Audited Account Returns</label>
                <input
                  type="file"
                  class="form-control"
                  (change)="onFileSelected($event, 'auditedAccounts')"
                />
                <small
                  *ngIf="this.uploadedFiles['auditedAccounts']?.fileName"
                  class="text-success"
                >
                  Selected:
                  {{ this.uploadedFiles["auditedAccounts"]?.fileName }}
                </small>
                <div
                  *ngIf="uploadedFiles['auditedAccounts']?.content"
                  class="mt-1"
                >
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    (click)="
                      previewFiles(
                        uploadedFiles['auditedAccounts'].content,
                        'viewDocumentDetails'
                      )
                    "
                  >
                    View PDF
                  </button>
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label m-0"
                  >Resolution of the General Body</label
                >
                <input
                  type="file"
                  class="form-control"
                  (change)="onFileSelected($event, 'resolutionGeneralBody')"
                />
                <small
                  *ngIf="this.uploadedFiles['resolutionGeneralBody']?.fileName"
                  class="text-success"
                >
                  Selected:
                  {{ this.uploadedFiles["resolutionGeneralBody"]?.fileName }}
                </small>
                <div
                  *ngIf="uploadedFiles['resolutionGeneralBody']?.content"
                  class="mt-1"
                >
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    (click)="
                      previewFiles(
                        uploadedFiles['resolutionGeneralBody'].content,
                        'viewDocumentDetails'
                      )
                    "
                  >
                    View PDF
                  </button>
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label m-0"
                  >Resolution of the Executive / Governing Body</label
                >
                <input
                  type="file"
                  class="form-control"
                  (change)="onFileSelected($event, 'resolutionExecutive')"
                />
                <small
                  *ngIf="this.uploadedFiles['resolutionExecutive']?.fileName"
                  class="text-success"
                >
                  Selected:
                  {{ this.uploadedFiles["resolutionExecutive"]?.fileName }}
                </small>
                <div
                  *ngIf="uploadedFiles['resolutionExecutive']?.content"
                  class="mt-1"
                >
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    (click)="
                      previewFiles(
                        uploadedFiles['resolutionExecutive'].content,
                        'viewDocumentDetails'
                      )
                    "
                  >
                    View PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary px-4"
          (click)="openMembersSection()"
        >
          Proceed and Review General/Governing Body Members
        </button>
      </div>
    </div>
  </form>
  <div
    class="modal fade animate-fade"
    id="confirmationAmendmentModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="election-title" id="exampleModalLabel">Confirmation ?</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          Please ensure that all required corrections and updates are completed
          before submitting the application. Once submitted, no further
          modifications will be permitted. We strongly recommend reviewing the
          bylaws carefully prior to proceeding. Would you like to proceed with
          applying for the amendments.

          <p>
            <input
              id="terms"
              type="checkbox"
              #confirmCheck
              [(ngModel)]="agree"
            />
            I agree!
          </p>
        </div>
        <div></div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            No
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!agree"
            (click)="submitAllData()"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="container py-3 mt-3" *ngIf="showMembersSection">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div
            class="card-header d-flex align-items-center justify-content-between"
          >
            <h5 class="election-title">General Body Members</h5>
            <button
              class="btn btn-primary btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#GeneralBodyMembers"
            >
              Add Member
            </button>
          </div>
          <!-- Modal -->
          <div
            class="modal fade"
            id="GeneralBodyMembers"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
            >
              <div class="modal-content" style="overflow-y: auto">
                <form [formGroup]="memberForm">
                  <div class="modal-header">
                    <h1 class="modal-title election-title" id="AddMemberLabel">
                      Add Member
                    </h1>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      (click)="resetMemberForm()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark">
                          {{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Name<span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Member Name"
                          formControlName="sMemName"
                          maxlength="50"
                          appCustomValidation="alphanumeric"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sMemName')?.errors &&
                              isSubmitMember,
                          }"
                        />

                        <div
                          *ngIf="
                            memberForm.get('sMemName')?.hasError('maxlength') &&
                            memberForm.get('sMemName')?.touched
                          "
                          class="text-danger"
                        >
                          Maximum 50 characters allowed.
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Age<span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Member Age"
                          formControlName="sMemAge"
                          (input)="filterNumbers($event)"
                          maxlength="3"
                          [max]="100"
                          [min]="18"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sMemAge')?.errors &&
                              isSubmitMember,
                          }"
                        />
                        <div
                          *ngIf="
                            memberForm.get('sMemAge')?.invalid &&
                            memberForm.get('sMemAge')?.touched
                          "
                        >
                          <small
                            class="text-danger"
                            *ngIf="memberForm.get('sMemAge')?.errors?.['min']"
                          >
                            Age must be at least 18.
                          </small>
                          <small
                            class="text-danger"
                            *ngIf="memberForm.get('sMemAge')?.errors?.['max']"
                          >
                            Age cannot be more than 100.
                          </small>
                          <small
                            class="text-danger"
                            *ngIf="
                              memberForm.get('sMemAge')?.errors?.['pattern']
                            "
                          >
                            Only numbers are allowed.
                          </small>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Gender<span class="text-danger">*</span></label
                        >

                        <select
                          class="form-select"
                          formControlName="iGenderid"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iGenderid')?.errors &&
                              isSubmitMember,
                          }"
                          (change)="getMaritalStatus($event)"
                        >
                          <option value="0">Select Gender</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                          <option value="3">Other</option>
                        </select>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Occupation<span class="text-danger">*</span></label
                        >
                        <select
                          class="form-select"
                          formControlName="iMemOccupation"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iMemOccupation')?.errors &&
                              isSubmitMember,
                          }"
                        >
                          <option value="0">Select Occupation</option>
                          <option
                            *ngFor="let item of occuptionList"
                            value="{{ item.id }}"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Marital Status<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <select
                          class="form-select"
                          formControlName="iMaritalSta"
                          (change)="getMaritalStatusChange($event)"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iMaritalSta')?.errors &&
                              isSubmitMember,
                          }"
                        >
                          <option value="0">Select Marital Status</option>
                          <option value="1">Unmarried</option>
                          <option value="2">Married</option>
                        </select>
                      </div>

                      <div
                        class="col-lg-4 col-md-6 mb-2"
                        *ngIf="showHusbandWife"
                      >
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Husband/Wife Name<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Husband/Wife Name"
                          formControlName="sMemHusName"
                          (keypress)="onlyAllowonespace($event)"
                          maxlength="50"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sMemHusName')?.errors &&
                              isSubmitMember,
                          }"
                        />
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2" *ngIf="showFather">
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society
                                                    Representative"
                              : "Member"
                          }}
                          Father Name<span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Father Name"
                          formControlName="sFatherName"
                          (keypress)="onlyAllowonespace($event)"
                          maxlength="50"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sFatherName')?.errors &&
                              isSubmitMember,
                          }"
                        />
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Member Identity Type<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <div class="d-flex align-items-center gap-2">
                          <select
                            #identityType
                            class="form-select"
                            formControlName="sAadharid"
                            (change)="onIdentityTypeChange(identityType.value)"
                            [ngClass]="{
                              'invalid-input':
                                memberForm.get('sAadharid')?.errors &&
                                isSubmitMember,
                            }"
                          >
                            <option value="" disabled selected>
                              Select Identity
                            </option>
                            <option value="aadhaarCard">Aadhaar Card</option>
                            <option value="voterId">Voter ID</option>
                            <option value="drivingLicense">
                              Driving License
                            </option>
                            <option value="panCard">Pan Card</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Member Identity No.<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <div class="d-flex align-items-center gap-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Identity ID"
                            formControlName="midentitynumber"
                            [attr.maxlength]="
                              selectedIdentityType === 'aadhaarCard'
                                ? 12
                                : selectedIdentityType === 'panCard'
                                  ? 10
                                  : selectedIdentityType === 'drivingLicense'
                                    ? 15
                                    : 20
                            "
                            [ngClass]="{
                              'invalid-input':
                                memberForm.get('midentitynumber')?.errors &&
                                isSubmitMember,
                            }"
                          />
                          <small
                            class="text-danger"
                            *ngIf="
                              memberForm.get('midentitynumber')?.errors?.[
                                'pattern'
                              ]
                            "
                          >
                            <ng-container [ngSwitch]="selectedIdentityType">
                              <span *ngSwitchCase="'aadhaarCard'">
                                Aadhaar number must be 12 digits
                              </span>
                              <span *ngSwitchCase="'voterId'">
                                Voter ID must be 3 letters followed by 7 numbers
                                (e.g., ABC1234567)
                              </span>
                              <span *ngSwitchCase="'drivingLicense'">
                                Driving License must be 15 alphanumeric
                                characters
                              </span>
                              <span *ngSwitchCase="'panCard'">
                                PAN must be in format: ABCDE1234F
                              </span>
                              <span *ngSwitchDefault>
                                Invalid Identity Number
                              </span>
                              <span *ngSwitchCase="'passport'"
                                >Enter valid Passport (A1234567).</span
                              >
                            </ng-container>
                          </small>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-3">
                        <!-- Label + View -->
                        <div
                          class="d-flex justify-content-between align-items-center mb-1"
                        >
                          <label for="formFile" class="form-label mb-0">
                            Upload Identity <span class="text-danger">*</span>
                          </label>

                          <a
                            *ngIf="aadhaarBase64"
                            href="javascript:void(0)"
                            class="text-decoration-none text-primary small fw-semibold d-inline-flex align-items-center"
                            (click)="
                              previewFiles(aadhaarBase64, 'IdentityDetails')
                            "
                          >
                            <i class="bi bi-link-45deg me-1 fs-5">View</i>
                          </a>
                          <a
                            *ngIf="
                              memberForm.get('sUploadAadharCardPath')?.value &&
                              !aadhaarBase64
                            "
                            href="javascript:void(0)"
                            class="text-decoration-none text-success small fw-semibold d-inline-flex align-items-center"
                            (click)="
                              downloadFile(
                                memberForm.get('sUploadAadharCardPath')?.value
                              )
                            "
                          >
                            <i class="bi bi-download fs-5"></i>
                          </a>
                        </div>

                        <!-- File Input -->
                        <input
                          class="form-control"
                          type="file"
                          id="formFile"
                          formControlName="sUploadAadharCardPath"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sUploadAadharCardPath')?.errors &&
                              isSubmitMember,
                          }"
                          (change)="onFileChange($event, 'uploadAadhaar')"
                        />

                        <!-- Help text -->
                        <small class="form-text text-muted">
                          Types: JPG, JPEG, PDF | Max size: 2 MB
                        </small>

                        <!-- Validation -->
                        <div
                          *ngIf="
                            (isSubmitMember ||
                              memberForm.get('sUploadAadharCardPath')
                                ?.touched) &&
                            memberForm.get('sUploadAadharCardPath')?.errors
                          "
                        >
                          <small
                            class="text-danger d-block"
                            *ngIf="
                              memberForm.get('sUploadAadharCardPath')?.errors?.[
                                'fileType'
                              ]
                            "
                          >
                            Only PDF files are allowed.
                          </small>

                          <small
                            class="text-danger d-block"
                            *ngIf="
                              memberForm.get('sUploadAadharCardPath')?.errors?.[
                                'fileSize'
                              ]
                            "
                          >
                            File size must be less than 2 MB.
                          </small>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Member Address Line 1<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Address"
                          formControlName="sAdd1"
                          appCustomValidation="alphanumeric"
                          maxlength="150"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sAdd1')?.errors && isSubmitMember,
                          }"
                        />

                        <div
                          *ngIf="
                            memberForm.get('sAdd1')?.errors?.['pattern'] &&
                            memberForm.get('sAdd1')?.touched
                          "
                        >
                          Please enter a valid address.
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Member Address Line 2
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Address"
                          formControlName="sAdd2"
                          appCustomValidation="alphanumeric"
                          maxlength="100"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sAdd2')?.errors && isSubmitMember,
                          }"
                        />
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark">
                          Membership Type<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <select
                          class="form-select"
                          formControlName="iMemberShipId"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iMemberShipId')?.errors &&
                              isSubmitMember,
                          }"
                        >
                          <option value="0">Select Type</option>
                          <option
                            *ngFor="let item of membershipTypeList"
                            value="{{ item.id }}"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Membership Fee<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Fee"
                          formControlName="sMemShipFee"
                          [maxlength]="8"
                          (keypress)="allowOnlyNumbers($event)"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('sMemShipFee')?.errors &&
                              isSubmitMember,
                          }"
                        />
                      </div>

                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >{{
                            this.memberForm.get("iMemTypeId")?.value == "2"
                              ? "Society"
                              : "Member"
                          }}
                          Designation<span class="text-danger">*</span></label
                        >
                        <select
                          class="form-select"
                          formControlName="iMemDesId"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iMemDesId')?.errors &&
                              isSubmitMember,
                          }"
                          (change)="onChangeDesignation()"
                        >
                          <option value="0">Select Designation</option>
                          <option
                            *ngFor="let item of designationList"
                            value="{{ item.id }}"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Member's Mobile Number<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Member's Mobile Number"
                          formControlName="iMemMobile"
                          (keypress)="allowOnlyNumbers($event)"
                          minlength="10"
                          maxlength="10"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iMemMobile')?.errors &&
                              isSubmitMember,
                          }"
                        />
                        <div
                          *ngIf="
                            memberForm.get('iMemMobile')?.invalid &&
                            memberForm.get('iMemMobile')?.touched
                          "
                        >
                          <small
                            class="text-danger"
                            *ngIf="
                              memberForm.get('iMemMobile')?.errors?.['pattern']
                            "
                          >
                            please Enter valid Mobile No
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label class="mb-1 text-dark"
                          >Member's Email Id<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Member's Email Id"
                          formControlName="iMemEmailId"
                          minlength="5"
                          maxlength="50"
                          [ngClass]="{
                            'invalid-input':
                              memberForm.get('iMemEmailId')?.errors &&
                              isSubmitMember,
                          }"
                        />
                        <div
                          *ngIf="
                            memberForm.get('iMemEmailId')?.invalid &&
                            memberForm.get('iMemEmailId')?.touched
                          "
                        >
                          <small
                            class="text-danger"
                            *ngIf="
                              memberForm.get('iMemEmailId')?.errors?.['pattern']
                            "
                          >
                            please Enter valid Email Id
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-danger"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      (click)="resetMemberForm()"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      (click)="submitMember()"
                      class="btn btn-primary"
                      [disabled]="isLoading"
                    >
                      {{ isLoading == true ? "Please wait..." : "Submit" }}
                    </button>
                  </div>
                </form>
              </div>
              <div class="modal fade" id="IdentityDetails">
                <div class="modal-dialog modal-xl modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Preview File</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>
                    <div class="modal-body text-center">
                      <iframe
                        [src]="base64Pdf"
                        style="width: 100%; height: 70vh; border: none"
                      >
                      </iframe>

                      <img
                        *ngIf="!aadhaarBase64?.includes('pdf')"
                        [src]="aadhaarBase64"
                        style="max-width: 100%; max-height: 70vh"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Modal -->
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Age</th>
                    <th>Gender</th>
                    <th>Father’s / Husband Name</th>
                    <th>Address</th>
                    <th>Marital Status</th>
                    <th>Occupation</th>
                    <th>Identity ID</th>
                    <th>Membership Type</th>
                    <th>Membership Fee</th>
                    <th>Designation</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of societyMemberList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.sMemName }}</td>
                    <td>{{ item.sMemAge }}</td>
                    <td>{{ item.sGender }}</td>
                    <td>
                      {{
                        item.sGender === "Male" &&
                        item.sMaritalStatus === "Married"
                          ? item.sFatherName
                          : item.sGender === "Female" &&
                              item.sMaritalStatus === "Married"
                            ? item.sMemHusName
                            : item.sFatherName
                      }}
                    </td>
                    <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                    <td>{{ item.sMaritalStatus }}</td>
                    <td>{{ item.sOccupation }}</td>
                    <td>{{ item.sAadharid }}</td>
                    <td>{{ item.sMembershiptypename }}</td>
                    <td>{{ item.sMemShipFee }}</td>
                    <td>{{ item.sMemberDesignation }}</td>
                    <td>
                      <div class="d-flex gap-2">
                        <button
                          class="btn btn-primary btn-sm"
                          (click)="downloadFile(item)"
                        >
                          <i class="bi bi-download"></i>
                        </button>

                        <button
                          class="btn btn-primary btn-sm"
                          (click)="OpenMemberDetails(item)"
                          data-bs-toggle="modal"
                          data-bs-target="#MemberDetail"
                        >
                          <i class="fa fa-user-circle"></i>
                        </button>
                        <button type="button" class="btn btn-info btn-sm">
                          <i
                            class="fa fa-pencil"
                            (click)="editMember(item, i)"
                            data-bs-toggle="modal"
                            data-bs-target="#GeneralBodyMembers"
                          ></i>
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          (click)="deleteMember(i)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="election-title">Governing Body Members</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Age</th>
                    <th>Gender</th>
                    <th>Address</th>
                    <th>Designation</th>
                    <th>Occupation</th>
                    <th>Membership Type</th>
                    <th>Aadhaar</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngFor="let item of filteredMembers; let i = index"
                  >
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.sMemName }}</td>
                      <td>{{ item.sMemAge }}</td>
                      <td>{{ item.sGender }}</td>
                      <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                      <td>{{ item.sMemberDesignation }}</td>
                      <td>{{ item.sOccupation }}</td>
                      <td>{{ item.sMembershiptypename }}</td>
                      <td>{{ item.sAadharid }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary px-4"
            (click)="openPreviewModal()"
          >
            Preview and Submit Application
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Member Detail Modal -->
  <div
    class="modal fade"
    id="MemberDetail"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="MemberDetailLabel"
    aria-hidden="true"
    style="background: rgba(0, 0, 0, 0.8)"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title election-title" id="MemberDetailLabel">
            Member Detail
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Occupation</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sOccupation"
                disabled
              />
            </div>

            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Marital Status</label>
              <input
                type="text"
                class="form-control"
                [value]="
                  selectedMember?.iMaritalSta == 1 ? 'Unmarried' : 'Married'
                "
                disabled
              />
            </div>

            <div
              class="col-lg-4 col-md-6 mb-2"
              *ngIf="
                selectedMember?.sMemHusName != null &&
                selectedMember?.sMemHusName != ''
              "
            >
              <label class="mb-1 text-dark">Member Husband/Wife Name</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sMemHusName"
                disabled
              />
            </div>

            <div
              class="col-lg-4 col-md-6 mb-2"
              *ngIf="
                selectedMember?.sFatherName != null &&
                selectedMember?.sFatherName != ''
              "
            >
              <label class="mb-1 text-dark">Member Father Name</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sFatherName"
                disabled
              />
            </div>

            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Member Aadhaar id</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sAadharid"
                disabled
              />
            </div>

            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Member Address Line 1</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sAdd1"
                disabled
              />
            </div>

            <div
              class="col-lg-4 col-md-6 mb-2"
              *ngIf="
                selectedMember?.sAdd2 != null && selectedMember?.sAdd2 != ''
              "
            >
              <label class="mb-1 text-dark">Member Address Line 2</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sAdd2"
                disabled
              />
            </div>

            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Membership Type</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sMembershiptypename"
                disabled
              />
            </div>

            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Membership Fee</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.sMemShipFee"
                disabled
              />
            </div>
            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Member's Mobile</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.iMemMobile"
                disabled
              />
            </div>
            <div class="col-lg-4 col-md-6 mb-2">
              <label class="mb-1 text-dark">Member's Email Id</label>
              <input
                type="text"
                class="form-control"
                [value]="selectedMember?.iMemEmailId"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="previewModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="previewModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="election-title">Amendment Application Preview</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container py-3 mt-3">
            <div class="row">
              <div class="col-lg-12">
                <div class="col-lg-12 text-center mb-3">
                  <img
                    src="../../assets/images/logos/hplogo.png"
                    alt="HP Logo"
                    class="gov-logo"
                  />
                  <div class="brand-title">
                    DEPARTMENT OF COOPERATION <br />
                    GOVERNMENT OF HIMACHAL PRADESH
                  </div>
                  <p class="text-center mt-1" style="font-size: 15px">
                    UNDER HP SOCIETIES REGISTRATION ACT, 2006
                  </p>
                </div>
                <!-- 
                                <div class="card mt-3">
                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <td style="width:30%">Amendment ID</td>
                                                        <th class="texture" style="width:20%">{{
                                                            this.societyDetails.sSocietyRegistrationNo ||
                                                            '-' }}</th>
                                                        <td style="width:30%">Amendment No.</td>
                                                        <th class="texture">{{ formData.amendmentNo || '-' }}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> -->

                <div class="card mt-3">
                  <div class="card-body">
                    <h5 class="election-title">
                      Details of the Person associated
                    </h5>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <tbody>
                          <tr>
                            <td style="width: 30%">Name</td>
                            <th class="texture" colspan="3">
                              {{ this.societyDetails.userName || "-" }}
                            </th>
                          </tr>
                          <tr>
                            <td>Address for Correspondence</td>
                            <th class="texture" colspan="3">
                              {{ this.societyDetails.sAddress1 || "-" }}
                            </th>
                          </tr>
                          <tr>
                            <td>Mobile</td>
                            <th class="texture" colspan="3">
                              {{ this.societyDetails.mobile || "-" }}
                            </th>
                          </tr>
                          <tr>
                            <td>Email ID</td>
                            <th class="texture" colspan="3">
                              {{ this.societyDetails.email || "-" }}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="card mt-3" *ngIf="amendmentsList?.length">
                  <div class="card-body">
                    <h5 class="election-title">Amendments Proposed in</h5>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <tbody>
                          <tr
                            *ngFor="let item of amendmentsList; let i = index"
                          >
                            <td style="width: 3%">{{ i + 1 }}.</td>
                            <td>{{ getAmendmentName(item.amendmentType) }}</td>
                            <td>
                              Resolution No. <b>{{ item.resolutionNo }}</b>
                              <span
                                class="text-muted"
                                *ngIf="item.resolutionDate"
                              >
                                (dated
                                <b>{{
                                  item.resolutionDate | date: "dd/MM/yyyy"
                                }}</b
                                >)
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- <div class="card mt-3" *ngIf="bylawsList?.length">
                                    <div class="card-body">
                                        <h5 class="election-title">Amendments in Objectives</h5>
                                        <div class="full-page-table table-responsive">
                                            <table class="table table-bordered">
                                                <thead class="texture">
                                                    <tr>
                                                        <th style="width:50%">Existing</th>
                                                        <th>Proposed</th>
                                                        <th>Reason for Change</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of bylawsList">
                                                        <td style="vertical-align:top">
                                                            <ul class="list-aligned margin-bottom-0">
                                                                <li>{{ item.existingDetails }}</li>
                                                            </ul>
                                                        </td>
                                                        <td style="vertical-align:top">
                                                            <ul class=" margin-bottom-0">
                                                                <li>{{ item.proposedChange }}</li>
                                                            </ul>
                                                        </td>
                                                        <td style="vertical-align:top">
                                                            <ol class="list-aligned margin-bottom-0">
                                                                <li>{{ item.purposesChange }}</li>
                                                            </ol>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> -->

                <!-- Detail sections: only for amendment types still in list + with Proposed -->
                <ng-container *ngFor="let item of bylawsList">
                  <div
                    class="card mt-3"
                    *ngIf="
                      isAmendmentTypeActive(item.type) &&
                      hasProposedContent(item.proposedChange)
                    "
                  >
                    <div class="card-body">
                      <h5 class="election-title">
                        Amendments in {{ getAmendmentName(item.type) }}
                      </h5>
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead class="texture">
                            <tr>
                              <th style="width: 50%">Existing</th>
                              <th>Proposed</th>
                              <th>Reason for Change</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="vertical-align: top">
                                <ul class="list-aligned margin-bottom-0">
                                  <li
                                    *ngFor="let detail of item.existingDetails"
                                  >
                                    {{ detail }}
                                  </li>
                                </ul>
                              </td>
                              <td style="vertical-align: top">
                                <ul class="list-aligned margin-bottom-0">
                                  <li *ngFor="let prop of item.proposedChange">
                                    {{ prop }}
                                  </li>
                                </ul>
                              </td>
                              <td style="vertical-align: top">
                                <ul class="list-aligned margin-bottom-0">
                                  <li
                                    *ngFor="let reason of item.purposesChange"
                                  >
                                    {{ reason }}
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div class="card mt-3" *ngIf="societyMemberList?.length">
                  <div class="card-body">
                    <h5 class="election-title">General Body Members</h5>
                    <div class="table-responsive">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>Age</th>
                            <th>Gender</th>
                            <th>Father’s / Husband Name</th>
                            <th>Address</th>
                            <th>Marital Status</th>
                            <th>Occupation</th>
                            <th>Aadhaar ID</th>
                            <th>Membership Type</th>
                            <th>Membership Fee</th>
                            <th>Designation</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let item of societyMemberList;
                              let i = index
                            "
                          >
                            <td>{{ i + 1 }}</td>
                            <td>{{ item.sMemName }}</td>
                            <td>{{ item.sMemAge }}</td>
                            <td>{{ item.sGender }}</td>
                            <td>
                              {{
                                item.sGender === "Male" &&
                                (item.sMaritalStatus === "Married" ||
                                  item.sMaritalStatus === "Unmarried")
                                  ? item.sFatherName
                                  : item.sGender === "Female" &&
                                      item.sMaritalStatus === "Married"
                                    ? item.sMemHusName
                                    : item.sFatherName
                              }}
                            </td>
                            <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                            <td>{{ item.sMaritalStatus }}</td>
                            <td>{{ item.sOccupation }}</td>
                            <td>{{ item.sAadharid }}</td>
                            <td>{{ item.sMembershiptypename }}</td>
                            <td>{{ item.sMemShipFee }}</td>
                            <td>{{ item.sMemberDesignation }}</td>
                            <td>
                              <button
                                class="btn btn-primary btn-sm"
                                (click)="downloadFile(item)"
                              >
                                <i class="bi bi-download"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="card mt-3" *ngIf="societyMemberList?.length">
                  <div class="card-body">
                    <h5 class="election-title">Governing Body Members</h5>
                    <div class="table-responsive">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>Age</th>
                            <th>Gender</th>
                            <th>Address</th>
                            <th>Designation</th>
                            <th>Occupation</th>
                            <th>Membership Type</th>
                            <th>Aadhaar</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="let item of filteredMembers; let i = index"
                          >
                            <tr>
                              <td>{{ i + 1 }}</td>
                              <td>{{ item.sMemName }}</td>
                              <td>{{ item.sMemAge }}</td>
                              <td>{{ item.sGender }}</td>
                              <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                              <td>{{ item.sMemberDesignation }}</td>
                              <td>{{ item.sOccupation }}</td>
                              <td>{{ item.sMembershiptypename }}</td>
                              <td>{{ item.sAadharid }}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="card mt-3">
                  <div class="card-body">
                    <h5 class="election-title">Requisite Documents</h5>
                    <div class="table-responsive">
                      <table
                        class="table table-hover table-bordered align-middle"
                      >
                        <thead class="table-light">
                          <tr>
                            <th>Sr. No</th>
                            <th>Document</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of Uploadedkeys; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ formatLabel(item) }}</td>

                            <td>
                              <button
                                *ngIf="uploadedFiles[item]?.content"
                                type="button"
                                class="btn btn-primary btn-sm me-1"
                                (click)="previewFile(uploadedFiles[item])"
                              >
                                <i class="bi bi-eye"></i>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="!Uploadedkeys?.length">
                            <td colspan="8" class="text-center text-muted">
                              No Files added yet.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="modal fade"
                  id="AmendmentsAppDetails"
                  tabindex="-1"
                  aria-labelledby="AmendmentsAppDetailsLabel"
                  aria-hidden="true"
                >
                  <div
                    class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
                  >
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Preview File</h5>
                        <button
                          type="button"
                          class="btn-close"
                          (click)="hideModal('AmendmentsAppDetails')"
                        ></button>
                      </div>

                      <div class="modal-body"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#confirmationAmendmentModal"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="viewDocumentDetails"
  tabindex="-1"
  aria-labelledby="AmendmentsAppDetailsLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Preview File</h5>
        <button
          type="button"
          class="btn-close"
          (click)="hideModal('viewDocumentDetails')"
        ></button>
      </div>

      <div class="modal-body" *ngIf="base64Pdf">
        <iframe
          [src]="base64Pdf"
          style="width: 100%; height: 70vh; border: none"
        >
        </iframe>
      </div>
    </div>
  </div>
</div>
